import React, { useEffect, useRef, useState } from "react";
import Layout from "../../layout";
import "react-datepicker/dist/react-datepicker.css";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { showPrice } from "../../utils/utils";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Moment from "react-moment";
import ReactGA from "react-ga4";
import { mainUrl } from "API/client/api";
import axios from "axios";

const STOCK_STATUS = ["IN", "OUT"];

const InventoryCheck = () => {
    const [tableData, setTableData] = useState([]);
    const [stockTableData, setStockTableData] = useState([]);
    const [stockTableDataFilter, setStockTableDataFilter] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [searchText, setSearchText] = useState("")

    const { userDetail } = useSelector(authenticationSeletor);
    let token = userDetail?.token

    useEffect(() => { window.scrollTo(0, 0); getDataHandlers(userDetail?.propertyId) }, []);

    const getDataHandlers = async (id) => {
        try {
            const res = await axios.get(`${mainUrl}api/inventory/inventory-property/${id}${searchText ? "?search=" + searchText : ""}`, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
            if (res.status == 200) { setStockTableData(res.data.data); }
        } catch (error) { console.log("Error in getDataHandlers...") }
    };

    useEffect(() => { getDataHandlers(userDetail?.propertyId) }, [searchText]);

    const tableRef = useRef();

    const exportTable = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Inventory Report");
            worksheet.columns = [
                { header: "Category", key: "category", width: 25 },
                { header: "Item", key: "item", width: 25 },
                { header: "Unit", key: "unit", width: 15 },
                { header: "Available Quantity", key: "qty", width: 20 },
                { header: "Price", key: "price", width: 15 },
                { header: "Exp. Date", key: "expDate", width: 20 },
                { header: "Status", key: "status", width: 25 }
            ];
            [...stockTableDataFilter].reverse().forEach((row) => {
                worksheet.addRow({
                    category: row?.InventoryCategory?.name || "N/A",
                    item: row.itemName,
                    unit: row.unit,
                    qty: row.avaiableQuantity ?? "N/A",
                    price: row.price,
                    expDate: row.expDate ? new Date(row.expDate).toLocaleDateString() : "N/A",
                    status: row?.avaiableQuantity < 10 ? "Low Quantity" : row?.avaiableQuantity < 20 ? "Average Quantity" : "Sufficient Quantity",
                });
            });
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `inventory_report.xlsx`);
        } catch (err) { console.error("Export error:", err); }
    };

    useEffect(() => { ReactGA.send({ hitType: "pageview", page: "inventory" }); setStockTableDataFilter(stockTableData) }, [stockTableData]);

    const searchfilter = (text, fromHeads = false, innerKey = null) => {
        const resultsData = stockTableData.filter((order) => {
            if (text == "") return stockTableData;
            let params = innerKey ? order[fromHeads]?.[innerKey] : order[fromHeads];
            if (fromHeads == "stockType") { params = STOCK_STATUS[order.stockType] }
            if (!fromHeads) { params = order?.Suplier?.name }
            return params?.toString().toLowerCase()?.includes(text?.toLowerCase());
        });
        setSearchText(text);
        setStockTableDataFilter(resultsData);
    };

    return (
        <Layout title="Inventory" extraBtnHandler={exportTable} extraButton={"Export Table"} searchfilter={searchfilter} searchType="search" searchPlaceHolder="Search..." setFromDate={setFromDate} setToDate={setToDate} fromDate={fromDate} toDate={toDate}>
            <div className="scrollTable">
                <Table striped bordered hover className="common-table" ref={tableRef}>
                    <thead>
                        <tr>
                            <th>
                                <span>Category</span>
                            </th>
                            <th>
                                <span>Item</span>
                            </th>
                            <th>
                                <span>Unit</span>
                            </th>
                            <th>
                                <span>Availabe Quantity</span>
                            </th>
                            <th>
                                <span>Price</span>
                            </th>
                            <th>
                                <span>Exp.Date</span>
                            </th>
                            <th>
                                <span>Status</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...stockTableDataFilter].reverse().map((data, key) => (
                            <tr key={key}>
                                <td>{data.InventoryCategory?.name}</td>
                                <td>{data.itemName}</td>
                                <td>{data.unit}</td>
                                <td>{data.avaiableQuantity ?? "N/A"}</td>
                                <td>{showPrice(data.price)}</td>
                                <td>{data.expDate && (<Moment format="DD MMM, YYYY">{data.expDate}</Moment>)}</td>
                                <td className={`inStock fw-bold ${data?.avaiableQuantity <= 5 ? "text-danger" : data?.avaiableQuantity < 20 ? "text-warning" : "text-success"}`}>{data?.avaiableQuantity < 10 ? "Low Quantity" : data?.avaiableQuantity < 20 ? "Average Quantity" : "Sufficient Quantity"}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Layout>
    );
};

export default InventoryCheck;
